import React, { useEffect, useState } from 'react'
import ReactExport from 'react-data-export'
import {Typography, Button, CircularProgress} from '@material-ui/core'
import { FaFileDownload } from 'react-icons/fa'
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const getData = (data, extended) => {
    let dataArr = []
    for(let i = 0 ; i < data.length; i++) {
        let dataObj = {}
        dataObj["label"] = data[i].Label
        dataObj["spend"] = data[i][extended][0].Cost
        dataObj["sales"] = data[i][extended][0].Sales
        dataObj["mailed"] = data[i][extended][0].Mailed
        dataObj["responses"] = data[i][extended][0].Responses
        dataObj["response_rate"] = data[i][extended][0].Mailed > 0 ? data[i][extended][0].Responses / data[i][extended][0].Mailed * 100 : 0
        dataObj["dmcoa"] = data[i][extended][0].Sales > 0 ? data[i][extended][0].Cost / data[i][extended][0].Sales * 100 : 0
        dataObj["costperthousand"] = data[i][extended][0].Mailed > 0 ? data[i][extended][0].Cost / data[i][extended][0].Mailed * 1000 : 0
        dataObj["totalcoa"] = data[i][extended][0].Total_Sales > 0 ? data[i][extended][0].Cost / data[i][extended][0].Total_Sales * 100 : 0
        dataObj["avgticket"] = data[i][extended][0].Responses > 0 ? data[i][extended][0].Sales / data[i][extended][0].Responses : 0
        dataObj["totalsales"] = data[i][extended][0].Total_Sales
        dataObj["pcttotal"] = data[i][extended][0].Total_Sales > 0 ? data[i][extended][0].Sales / data[i][extended][0].Total_Sales * 100 : 0
        dataObj["contribution"] = "N/A"
        dataArr.push(dataObj)
    }
    
    return dataArr
}

const EventExport = (props) => {
    const { promoName, format, selectedType, markets, roiData, locationData, rfmData, testData, dateExtended } = props
    let location = locationData.length > 0 ? getData(locationData, dateExtended) : []
    let rfm = rfmData.length > 0 ? getData(rfmData, dateExtended) : []
    let test = testData.length > 0 ? getData(testData, dateExtended) : []

    // console.log(roiData)
    
    const multiDataSet = [
        {
            columns: [
                {title:`${promoName} ROI SUMMARY`, width: {wpx: 500}, style: {font: {sz: "20", bold: true}}},
            ],
            data: [
                [
                    {value: `SHOWING: Promotion Dates between ${roiData.PromoStartDate} and ${roiData.PromoEndDate}`},
                ],
                [
                    {value: `FORMAT: ${format}`}
                ],
                [
                    {value: `${selectedType.toUpperCase()}(S) SELECTED: ${markets}`}
                ],
            ]
        },
        {
            ySteps: 2,
            columns: [
                {title: "PROMOTION SUMMARY", width: {wpx: 350}, style: {font: {sz: "15", bold: true}}}
            ],
            data: [[]]
        },
        {
            columns: [
                {title: 'Status', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Spend', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Mailed', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Responses', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Response Rate', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'DM CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Cost Per Thousand', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Average Ticket', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: '% of Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Contribution Margin ROI', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
            ],
            data: roiData.length > 0 ? [
                [
                    {value: "Mailed"},
                    {value: "$" + Math.round(roiData.Cost).toLocaleString("en")},
                    {value: Math.round(roiData.Mailed).toLocaleString("en")},
                    {value: (roiData.Responses).toLocaleString("en")},
                    {value: "$" + Math.round(roiData.Sales).toLocaleString("en")},
                    {value: (roiData.Res_Rate * 100).toFixed(2) + "%"},
                    {value: `${roiData.Sales > 0 ? (roiData.Cost / roiData.Sales * 100).toFixed(2) : 0}%`},
                    {value: `$${roiData.Mailed > 0 ? Math.round(roiData.Cost / roiData.Mailed * 1000).toLocaleString("en") : 0}`},
                    {value: `${roiData.Total_Sales > 0 ? (roiData.Cost / roiData.Total_Sales * 100).toFixed(2) : 0}%`},
                    {value: `$${roiData.Responses > 0 ? Math.round(roiData.Sales / roiData.Responses).toLocaleString("en") : 0}`},
                    {value: `$${Math.round(roiData.Total_Sales).toLocaleString("en")}`},
                    {value: `${roiData.Total_Sales > 0 ? (roiData.Sales / roiData.Total_Sales * 100).toFixed(2) : 0}%`},
                    {value: "N/A"},                    
                ],
                [
                    {value: "Holdout"},
                    {value: `$${0}`},
                    {value: `${Math.round(roiData.HO_Count).toLocaleString("en")}`},
                    {value: `${(roiData.HO_Resp).toLocaleString("en")}`},
                    {value: `$${Math.round(roiData.HO_Sales).toLocaleString("en")}`},
                    {value: `${roiData.HO_Res_Rate > 0 ? (roiData.HO_Res_Rate * 100).toFixed(2) : 0}%`},
                    {value: ""},
                    {value: ""},
                    {value: ""},
                    {value: `$${roiData.HO_Resp > 0 ? Math.round(roiData.HO_Sales / roiData.HO_Resp).toLocaleString("en") : 0}`},
                    {value: `$${Math.round(roiData.Total_Sales).toLocaleString("en")}`},
                    {value: `${roiData.Total_Sales > 0 ? (roiData.HO_Sales / roiData.Total_Sales * 100).toFixed(2) : 0}%`},
                    {value: "N/A"},                    
                ],
                [
                    {value: "Adjusted"},
                    {value: `$${Math.round(roiData.Cost).toLocaleString("en")}`},
                    {value: `${Math.round(roiData.Mailed).toLocaleString("en")}`},
                    {value: `${(roiData.Res_Rate - roiData.HO_Res_Rate > 0) ? Math.round(roiData.Mailed * (roiData.Res_Rate - roiData.HO_Res_Rate)).toLocaleString("en") : 0}`},
                    {value: `$${(roiData.Res_Rate - roiData.HO_Res_Rate > 0) ? Math.round(roiData.Sales / roiData.Res_Rate * (roiData.Res_Rate - roiData.HO_Res_Rate)).toLocaleString("en") : 0}`},
                    {value: `${(roiData.Res_Rate - roiData.HO_Res_Rate > 0) ? ((roiData.Res_Rate - roiData.HO_Res_Rate) * 100).toFixed(2) : 0}%`},
                    {value: `${(roiData.Res_Rate - roiData.HO_Res_Rate > 0) ? (roiData.Cost / (roiData.Sales / roiData.Res_Rate * (roiData.Res_Rate - roiData.HO_Res_Rate)) * 100).toFixed(2) : 0}%`},
                    {value: `$${roiData.Mailed > 0 ? Math.round(roiData.Cost / roiData.Mailed * 1000).toLocaleString("en") : 0}`},
                    {value: `${roiData.Total_Sales > 0 ? (roiData.Cost / roiData.Total_Sales * 100).toFixed(2) : 0}%`},
                    {value: `$${Math.round(roiData.Res_Rate - roiData.HO_Res_Rate > 0) ? ((roiData.Sales / roiData.Res_Rate * (roiData.Res_Rate - roiData.HO_Res_Rate)) / (roiData.Mailed * (roiData.Res_Rate - roiData.HO_Res_Rate))).toLocaleString("en") : 0}`},
                    {value: `$${Math.round(roiData.Total_Sales).toLocaleString("en")}`},
                    {value: `${roiData.Res_Rate - roiData.HO_Res_Rate > 0 ? ((roiData.Sales / roiData.Res_Rate * (roiData.Res_Rate - roiData.HO_Res_Rate)) / roiData.Total_Sales * 100).toFixed(2) : 0.00}%`},
                    {value: "N/A"},                    
                ],                
            ] : [[]]
        },
        {
            ySteps: locationData.length > 0 ? 2 : 0,
            columns: locationData.length > 0 ? [
                {title: "ROI BY LOCATION", width: {wpx: 350}, style: {font: {sz: "15", bold: true}}}
            ] : [],
            data: [[]]
        },
        {
            columns: locationData.length > 0 ? [
                {title: 'Location', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Spend', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Mailed', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Responses', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Response Rate', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'DM CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Cost Per Thousand', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Average Ticket', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: '% of Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Contribution Margin ROI', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
            ] : [],
            data: locationData.length > 0 ? location.map(({label, spend, sales, mailed, responses, response_rate, dmcoa, costperthousand, totalcoa, avgticket, totalsales, pcttotal, contribution }) => (
                [
                    {value: label },
                    {value: "$" + Math.round(spend).toLocaleString("en")},
                    {value: Math.round(mailed).toLocaleString("en")},
                    {value: Math.round(responses).toLocaleString("en")},
                    {value: "$" + Math.round(sales).toLocaleString("en")},
                    {value: response_rate.toFixed(2) + "%"},
                    {value: dmcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(costperthousand).toLocaleString("en")},
                    {value: totalcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(avgticket).toLocaleString("en")},
                    {value: "$" + Math.round(totalsales).toLocaleString("en")},
                    {value: pcttotal.toFixed(2) + "%"},
                    {value: contribution}
                ]    
            )) : [[]]
        },
        {
            ySteps: locationData.length > 0 ? 2 : 0,
            columns: locationData.length > 0 ? [
                {title: "ROI BY RFM", width: {wpx: 350}, style: {font: {sz: "15", bold: true}}}
            ] : [],
            data: [[]]
        },
        {
            columns: rfmData.length > 0 ? [
                {title: 'RFM Segment', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Spend', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Mailed', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Responses', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Response Rate', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'DM CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Cost Per Thousand', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Average Ticket', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: '% of Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Contribution Margin ROI', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
            ] : [],
            data: rfmData.length > 0 ? rfm.map(({label, spend, sales, mailed, responses, response_rate, dmcoa, costperthousand, totalcoa, avgticket, totalsales, pcttotal, contribution }) => (
                [
                    {value: label },
                    {value: "$" + Math.round(spend).toLocaleString("en")},
                    {value: Math.round(mailed).toLocaleString("en")},
                    {value: Math.round(responses).toLocaleString("en")},
                    {value: "$" + Math.round(sales).toLocaleString("en")},
                    {value: response_rate.toFixed(2) + "%"},
                    {value: dmcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(costperthousand).toLocaleString("en")},
                    {value: totalcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(avgticket).toLocaleString("en")},
                    {value: "$" + Math.round(totalsales).toLocaleString("en")},
                    {value: pcttotal.toFixed(2) + "%"},
                    {value: contribution}
                ]    
            )) : [[]]
        },
        {
            ySteps: locationData.length > 0 ? 2 : 0,
            columns: locationData.length > 0 ? [
                {title: "ROI BY TEST GROUPS", width: {wpx: 350}, style: {font: {sz: "15", bold: true}}}
            ] : [],
            data: [[]]
        },
        {
            columns: testData.length > 0 ? [
                {title: 'Test Group', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Spend', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Mailed', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Responses', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Response Rate', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'DM CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Cost Per Thousand', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total CoA(%)', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Average Ticket', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: '% of Total Sales', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
                {title: 'Contribution Margin ROI', width: {wpx: 150}, style: {font: {sz: '12', bold: true}}},
            ] : [],
            data: testData.length > 0 ? test.map(({label, spend, sales, mailed, responses, response_rate, dmcoa, costperthousand, totalcoa, avgticket, totalsales, pcttotal, contribution }) => (
                [
                    {value: label },
                    {value: "$" + Math.round(spend).toLocaleString("en")},
                    {value: Math.round(mailed).toLocaleString("en")},
                    {value: Math.round(responses).toLocaleString("en")},
                    {value: "$" + Math.round(sales).toLocaleString("en")},
                    {value: response_rate.toFixed(2) + "%"},
                    {value: dmcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(costperthousand).toLocaleString("en")},
                    {value: totalcoa.toFixed(2) + "%"},
                    {value: "$" + Math.round(avgticket).toLocaleString("en")},
                    {value: "$" + Math.round(totalsales).toLocaleString("en")},
                    {value: pcttotal.toFixed(2) + "%"},
                    {value: contribution}
                ]    
            )) : [[]]
        },
    ]

    if(!roiData) return <CircularProgress />
    
    return (
        <ExcelFile
            filename={`${promoName}_ROI(${moment().format("YYYY-MM-DD")})`}
            element={
                <Button
                    variant="outlined"
                    className="export-btn"
                >
                    <Typography variant="caption">EXPORT PROMO ROI</Typography>                    
                    <FaFileDownload className="export-btn-icon" />
                </Button>
            }
        >
            <ExcelSheet dataSet={multiDataSet} name={promoName}/>            
        </ExcelFile>
    )
}

export default EventExport